import CryptoJS from 'crypto-js';
import axios from 'axios';
import { btoa, atob } from '../../lib/helpers';

const permission = {
  namespaced: true,

  state() {
    return {
      allPermissions: [],
      totalPermissions: 0,
      assignedPermissions: [],
      totalAssignedPermissions: 0,
      loading: false,
      loadingActivePermission: false,
      permissionCache: {},
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      allActivePermission: [],
      requestActivePermission: null,
      totalPage: 0,
    };
  },

  mutations: {
    setPermissions(state, { payload }) {
      state.allPermissions = payload.data;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearPermissions(state) {
      state.allPermissions = [];
      state.totalPermissions = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalPermissions(state, { payload }) {
      state.totalPermissions = parseInt(payload.data.length, 10);
    },

    setAssignedPermissions(state, { payload }) {
      state.assignedPermissions = payload.data;
    },
    setTotalAssignedPermissions(state, { payload }) {
      state.totalAssignedPermissions = parseInt(payload.data.length, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setLoadingActivePermission(state, loadingActivePermission) {
      state.loadingActivePermission = loadingActivePermission;
    },

    // eslint-disable-next-line no-shadow
    removePermission(state, { permission }) {
      state.totalPermissions -= 1;
      state.allPermissions = state.allPermissions.filter(
        (value) => value.permission != permission
      );
    },
    clearErrorVariable(state, variable) {
      state.errors[variable] = [];
    },

    pushPermission(state, { payload }) {
      state.allPermissions.push(payload);
      state.totalPermissions += 1;
    },

    editPermission(state, { payload, index }) {
      Object.assign(state.allPermissions[index], payload);
    },

    setActivePermissions(state, { payload }) {
      state.allActivePermission = payload.data;
    },

    concatAssignedPermission(state, payload) {
      state.assignedPermissions.concat(payload);
    },

    pushAssignedPermission(state, payload) {
      state.assignedPermissions.push(payload);
    },
  },

  actions: {
    async fetchPermissions(ctx, { date, role }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        role,
        version: btoa(
          CryptoJS.SHA256(
            role + date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/rbac/permission/list`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      await axios(config)
        .then((response) => {
          if (response.data.code != '200') {
            if (localStorage.getItem('language_qram') == null) {
              ctx.commit('setFlashErrorMessage', response.data.message_id);
            } else {
              ctx.commit('setFlashErrorMessage', response.data.message_en);
            }

            if (response.data.code == '401') {
              ctx.dispatch('logout', null, { root: true });
            }
          } else if (role == '') {
            ctx.commit('setTotalPermissions', {
              payload: response.data,
            });
            ctx.commit('setPermissions', {
              payload: response.data,
            });
          } else {
            ctx.commit('setTotalAssignedPermissions', {
              payload: response.data,
            });
            ctx.commit('setAssignedPermissions', {
              payload: response.data,
            });
          }
        })
        .catch((error) => {
          if (error.response.status == '403') {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: error.response.data.message,
                icon: 'mdi-alert',
                color: 'red',
              },
              { root: true }
            );
          } else if (error.response.status == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
        });

      ctx.commit('setLoading', false);
    },

    async fetchActivePermissions(ctx, { date }) {
      ctx.commit('clearPermissions');
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        user_id: '',
        version: btoa(
          CryptoJS.SHA256(
            `${date}${atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))}`
          ).toString()
        ),
      });
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/rbac/permission/list`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      await axios(config)
        .then((response) => {
          if (response.data.code != '200') {
            if (localStorage.getItem('language_qram') == null) {
              ctx.commit('setFlashErrorMessage', response.data.message_id);
            } else {
              ctx.commit('setFlashErrorMessage', response.data.message_en);
            }

            if (response.data.code == '401') {
              ctx.dispatch('logout', null, { root: true });
            }
          } else {
            ctx.commit('setActivePermissions', {
              payload: response.data,
            });
          }
        })
        .catch((error) => {
          if (error.response.status == '403') {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: error.response.data.message,
                icon: 'mdi-alert',
                color: 'red',
              },
              { root: true }
            );
          } else if (error.response.status == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
        });

      ctx.commit('setLoading', false);
    },

    // eslint-disable-next-line no-shadow
    async createPermission(ctx, { date, permission, description }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        permission,
        description,
        version: btoa(
          CryptoJS.SHA256(
            permission +
              description +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/rbac/permission/add`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      return axios(config)
        .then((response) => {
          if (response.data.code != '200') {
            ctx.commit('setErrors', response.data.data);
            if (localStorage.getItem('language_qram') == null) {
              ctx.commit('setFlashErrorMessage', response.data.message_id);
            } else {
              ctx.commit('setFlashErrorMessage', response.data.message_en);
            }
            return false;
          }
          ctx.commit('pushPermission', {
            payload: { permission },
          });
          return true;
        })
        .catch((error) => {
          if (error.response.status == '403') {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: error.response.data.message,
                icon: 'mdi-alert',
                color: 'red',
              },
              { root: true }
            );
          } else if (error.response.status == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
          return false;
        })
        .finally(() => {
          ctx.commit('setLoading', false);
        });
    },

    // eslint-disable-next-line no-shadow
    async updatePermission(ctx, { date, permission, description, index }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id: index,
        permission,
        description,
        version: btoa(
          CryptoJS.SHA256(
            index.toString() +
              permission.toString() +
              description +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/rbac/permission/update`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      return axios(config)
        .then((response) => {
          if (response.data.code != '200') {
            ctx.commit('setErrors', response.data.data);
            if (localStorage.getItem('language_qram') == null) {
              ctx.commit('setFlashErrorMessage', response.data.message_id);
            } else {
              ctx.commit('setFlashErrorMessage', response.data.message_en);
            }
            return false;
          }
          const updatedPermission = response.data.data;
          ctx.commit('editPermission', {
            payload: updatedPermission,
            index,
          });
          return true;
        })
        .catch(() => false)
        .finally(() => {
          ctx.commit('setLoading', false);
        });
    },

    // eslint-disable-next-line no-shadow
    async deletePermission(ctx, { date, permission }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        permission,
        version: btoa(
          CryptoJS.SHA256(
            permission.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/rbac/permission/delete`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      return axios(config)
        .then((response) => {
          if (response.data.code != '200') {
            if (localStorage.getItem('language_qram') == null) {
              ctx.commit('setFlashErrorMessage', response.data.message_id);
            } else {
              ctx.commit('setFlashErrorMessage', response.data.message_en);
            }
            return false;
          }
          ctx.commit('removePermission', {
            permission,
          });
          return true;
        })
        .catch(() => false)
        .finally(() => {
          ctx.commit('setLoading', false);
        });
    },
  },
};
export default permission;
